import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Output,
    ViewChild,
    EventEmitter,
} from "@angular/core";

import { Division } from "../data/model";
import { PersistenceService } from "../store/model/persistence.service";
import { BehaviorSubject, Subject } from "rxjs";
import { KeycloakService } from "../security";

@Component({
    selector: "zbd-main-menu",
    templateUrl: "main-menu.component.html",
    styleUrls: ["main-menu.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuComponent {
    @Input() hasHome = true;
    @ViewChild("dropdown") dropdown;

    constructor(
        private persistence: PersistenceService,
        private keycloak: KeycloakService,
    ) {}

    toggle(): void {
        const el = this.dropdown.nativeElement;
        if (el.style.display === "block") {
            el.style.display = "none";
        } else {
            el.style.display = "block";
        }
    }

    logout(): void {
        // TODO: Get base URL from Angular router
        const baseTags = document.getElementsByTagName("base");
        const redirectUri =
            baseTags.length > 0 ? baseTags[0].href : window.location.href;
        this.keycloak.logout({
            redirectUri: redirectUri,
        });
    }
}
